<div class="delete-modal-content">
  <div class="delete-modal-header">
    <h2 class="delete-modal-title">Delete Project</h2>
  </div>

  <div class="delete-modal-body">
    <p class="confirm-text">
      {{ projectDeleteMsg }}
    </p>
    <p class="warning-text">You cannot undo this action.</p>
    <label class="chat-checkbox-label">
      <span class="custom-checkbox">
        <input type="checkbox" [(ngModel)]="deleteChats" [ngModelOptions]="{ standalone: true }" (keydown.enter)="onCheckboxKey($event)" />
        <span class="checkmark"></span>
      </span>
      <span>{{ chatCountMsg }}</span>
    </label>

    <gains-input
      *ngIf="isSingleProject"
      label="Type Project Name"
      type="text"
      placeholder="Enter project name..."
      [(ngModel)]="typedProjectName"
      [ngModelOptions]="{ standalone: true }"
    />
  </div>

  <div class="delete-modal-footer">
    <button class="footer-btn" nz-button nzType="default" (click)="onCancel()">Cancel</button>
    <button class="footer-btn dlt-btn" nz-button nzType="primary" [disabled]="isDeleteDisabled" (click)="onDelete()">Delete</button>
  </div>
</div>
